import qs from 'query-string';
import {
  API_ENDPOINT,
  type ClientApiV1ReviewsCourseUserUserIdReceivedQueryString,
  useClientApiV1ReviewsCourseUserUserIdReceivedQuery,
} from '../../resources/@types/uccSchema';

const DEFAULT_QUERY_PARAMS = {
  pageNumber: 1,
  pageSize: 5,
};

interface UseClientV1ReviewsCourseUserUserIdReceivedQuery {
  userId: string;
  queryObject?: Partial<ClientApiV1ReviewsCourseUserUserIdReceivedQueryString>;
  options?: Parameters<typeof useClientApiV1ReviewsCourseUserUserIdReceivedQuery>[0]['options'];
}

export function useReviewsCourseUserUserIdReceivedQuery({
  userId,
  queryObject,
  options,
}: UseClientV1ReviewsCourseUserUserIdReceivedQuery) {
  return useClientApiV1ReviewsCourseUserUserIdReceivedQuery({
    queryKey: getUseReviewsCourseUserUserIdReceivedQueryKey({ userId, ...queryObject }),
    url: getUseReviewsCourseUserUserIdReceivedQueryUrl({ userId, ...queryObject }),
    options,
  });
}
export const getUseReviewsCourseUserUserIdReceivedQueryKey = ({
  userId,
  ...queryObject
}: { userId: string } & Partial<ClientApiV1ReviewsCourseUserUserIdReceivedQueryString>) => [
  API_ENDPOINT.CLIENT_V1_REVIEWS_COURSE_USER_USERID_RECEIVED(userId),
  { ...DEFAULT_QUERY_PARAMS, ...queryObject },
];

export const getUseReviewsCourseUserUserIdReceivedQueryUrl = ({
  userId,
  ...queryObject
}: { userId: string } & Partial<ClientApiV1ReviewsCourseUserUserIdReceivedQueryString>) =>
  qs.stringifyUrl({
    url: API_ENDPOINT.CLIENT_V1_REVIEWS_COURSE_USER_USERID_RECEIVED(userId),
    query: {
      ...DEFAULT_QUERY_PARAMS,
      ...queryObject,
    },
  });
